<script>
import Favorite from "../lib/favorite.vue"
import channelPrivateButton from '../channel/channel-private-button.vue'

export default {
  components: {Favorite, channelPrivateButton},
  props: {
    speakerId: {type: String, required: true},
    eventShortName: {type: String, default: undefined},
  },

  data() {
    return {
      speaker: {},
    }
  },

  computed: {
    shortName() {
      return this.eventShortName || this.$route.params.shortName
    }
  },

  watch: {
    speakerId: {
      handler(newValue) {
        this.fetchSpeaker()
      },
    },
  },

  created() {
    this.fetchSpeaker()
  },

  methods: {
    sessionGenerator: function* generatorFunction(sessions) {
      for (const session of sessions) {
        if (this.shortName) {
          if (this.shortName === session.event_short_name) {
            yield session
          }
        } else
          yield session
      }
    },

    filteredSessions(sessions) {
      return this.sessionGenerator(sessions)
    },

    speakerFullName: function (speaker) {
      return [speaker.title, speaker.first_name, speaker.last_name].join(' ').trim()
    },

    fetchSpeaker: function () {
      let me = this
      this.$api.get(`speakers/${this.speakerId}/`).then(function(response) {
        me.speaker = response.data
      }).catch(function(error){console.error(error)})
    },
  },


}
</script>

<template>
  <div v-if="speaker.content_code" class="card mb-2">
    <favorite attr="speaker" :value="speaker.content_code"
      :obj="speaker" extra-css="p-2 ml-auto"
      @favorite-changed="$emit('favorite-changed', $event)" />
    <img :src="speaker.profile_img_url" class="avatar mx-auto" />
    <div class="card-body text-center">
      <h4 class="card-title mb-0">{{speakerFullName(speaker)}}</h4>
      <p v-if="speaker.job_title" class="text-muted">
        <small>{{speaker.job_title}}</small>
        <small v-if="speaker.sessions_chaired.length"><br>Moderator:in</small>
      </p>
      <p v-if="speaker.company">{{speaker.company}}</p>
      <channel-private-button v-if="speaker.mm_user_id" :contactId="speaker.mm_user_id" />
      <hr>
      <template v-if="speaker.description">
        <h3 class="text-start">Biographie</h3>
        <div class="text-start mb-3" v-html="speaker.description"></div>
      </template>
      <h3 class="text-start">Sessions</h3>

      <talk-detail v-for="talk in filteredSessions(speaker.sessions)" class="mb-3 text-start" :key="talk.id"
        :talk="talk" :language-display="false"
        @favorite-changed="$emit('mark', $event)" :list-display="true" />

      <hr>
      <h3 class="text-start">Moderierte Sessions</h3>
      <talk-detail v-for="talk in filteredSessions(speaker.sessions_chaired)" class="mb-3 text-start" :key="talk.id"
        :talk="talk" :language-display="false"
        @favorite-changed="$emit('mark', $event)" :list-display="true" />
    </div>
  </div>
  <div v-else>
    <h2 class="text-center">not found</h2>
  </div>
</template>

<style scoped>

.c-session {
  border-top: 1px solid lightgrey;
}

hr {
  border-color: lightgrey;
}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

</style>